var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.rootStyle)},[_c('v-content',{class:_vm.cssClass},[_c('v-container',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('app-footer',{attrs:{"app":""}})],1),_c('cookies-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }